// Acción lista tabla altas
export const LISTA_INDICADORES_REQUEST = 'LISTA_INDICADORES_REQUEST';
export const LISTA_INDICADORES_FAIL = 'LISTA_INDICADORES_FAIL';
export const LISTA_INDICADORES_SUCCESS = 'LISTA_INDICADORES_SUCCESS';

export const LISTA_UTM_SUCCESS = 'LISTA_UTM_SUCCESS';
export const LISTA_UF_SUCCESS = 'LISTA_UF_SUCCESS';
export const LISTA_DOLAR_SUCCESS = 'LISTA_DOLAR_SUCCESS';
export const LISTA_BITCOIN_SUCCESS = 'LISTA_BITCOIN_SUCCESS';
export const LISTA_IPC_SUCCESS = 'LISTA_IPC_SUCCESS';
export const LISTA_EURO_SUCCESS = 'LISTA_EURO_SUCCESS';
export const LISTA_ETHEREUM_SUCCESS = 'LISTA_ETHEREUM_SUCCESS';


export const DARK_MODE = 'DARK_MODE';
export const SIDEBAR_COLLAPSED = 'SIDEBAR_COLLAPSED';
// Acción GET pregunta ia
export const PREGUNTA_IA_SUCCESS = 'PREGUNTA_IA_SUCCESS';
export const PREGUNTA_IA_FAIL = 'PREGUNTA_IA_FAIL';
export const PREGUNTA_IA_REQUEST = 'PREGUNTA_IA_REQUEST';
export const MOSTRAR_N_PAGINACION = 'MOSTRAR_N_PAGINACION';


export const ACTUALIZAR_INDICADOR_HABILITADO = 'ACTUALIZAR_INDICADOR_HABILITADO';